// eslint-disable-next-line no-restricted-syntax
export enum DataPrivacyAgreementType {
  GOOGLE = 'GOOGLE',
  IBM = 'IBM',
  GWG = 'GOOGLE_GWG',
  TRIAL = 'TRIAL',
}
